import { Role } from '@/api/RoleApi';
import { BaseEntity } from '@/api/EntityApi';
import { UUID } from '@/types/types';

export enum UserStatus {
	INACTIVE = 'INACTIVE',
	ACTIVE = 'ACTIVE',
	SUSPENDED = 'SUSPENDED',
}

export enum UserType {
	ADMIN = 'admin',
	USER = 'user',
}

interface BaseUser extends BaseEntity {
	email: string;
	firstName: string;
	lastName: string;
	password: string;
	status: UserStatus;
	userType: UserType;
}

export interface Admin extends BaseUser {
	role: Role;
	userType: UserType.ADMIN;
}

export interface ProductTypeDiscount {
	id: UUID;
	userId: UUID;
	productTypeId: UUID;
	discount: number;
	createdAt: string;
	updatedAt: string;
}

export interface ProductTypeFabricCategoryDiscount {
	id: UUID;
	userId: UUID;
	productTypeId: UUID;
	fabricCategoryId: UUID;
	discount: number;
	createdAt: string;
	updatedAt: string;
}

export interface User extends BaseUser {
	phoneNumber: string;
	discount: number;
	productTypeDiscounts?: ProductTypeDiscount[];
	fabricCategoryDiscounts?: ProductTypeFabricCategoryDiscount[];
	street: string;
	postalCode: string;
	city: string;
	userType: UserType.USER;
}

export type AppUser = Admin;
